export const works = [
  {
    id: "silent-witness",
    title: "无声的证词",
    year: 2024,
    category: "悬疑推理",
    status: "已完结",
    director: "林正声",
    cast: ["天海翼", "程知远", "苏婉"],
    releaseDate: "2024-03-18",
    duration: "45分钟/集 · 共24集",
    region: "中国大陆",
    rating: 8.7,
    popularity: 96,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20crime%20drama%20poster%2C%20rainy%20noir%20street%20at%20night%2C%20cold%20blue%20ambiance%2C%20dramatic%20movie%20lighting%2C%20moody%20atmosphere%2C%20no%20text&width=600&height=800&seq=thyi-work-01&orientation=portrait",
    summary: "一桩沉寂多年的旧案重新浮出水面，法医与刑警在沉默的证据间追寻真相。",
    synopsis: [
      "《无声的证词》以一起尘封十二年的失踪案为起点，讲述法医顾问林知夏（天海翼 饰）与刑警队长程知远因一具意外出土的遗骸重新走到一起。两人从彼此怀疑到并肩作战，在浩繁的资料与沉默的物证中，一层层剥开被掩埋的真相。",
      "剧集以冷峻的影像质感和缜密的推理逻辑见长，节奏张弛有度。天海翼在剧中一改往日形象，塑造了一位克制、敏锐而内心柔软的职场女性，被观众称为其表演生涯的一次突破。",
      "全剧共24集，围绕三条时间线交织展开，最终在结局处将对真相的追问落到对人性与救赎的思考上。",
    ],
    tags: ["悬疑", "犯罪", "推理", "都市"],
  },
  {
    id: "city-lights",
    title: "都市的微光",
    year: 2023,
    category: "都市情感",
    status: "已完结",
    director: "张亦然",
    cast: ["天海翼", "林晟", "何静"],
    releaseDate: "2023-09-02",
    duration: "42分钟/集 · 共30集",
    region: "中国大陆",
    rating: 8.2,
    popularity: 88,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20urban%20romance%20poster%2C%20city%20skyline%20at%20dusk%20with%20warm%20street%20lights%2C%20soft%20glow%2C%20modern%20drama%20mood%2C%20no%20text&width=600&height=800&seq=thyi-work-02&orientation=portrait",
    summary: "三个普通家庭的都市群像，讲述平凡生活里那些微小却倔强的光。",
    synopsis: [
      "《都市的微光》以一座快速扩张的城市为背景，通过三个普通家庭一年之间的生活变迁，描摹当代都市人的生存状态。天海翼饰演的社工沈栀，游走在社区与家庭之间，用善意串联起陌生人的命运。",
      "剧集不追求戏剧化的强冲突，而是以细腻的日常细节和克制的情绪表达打动观众，被赞为“写给普通人的温柔情书”。",
      "作品播出后长期稳居同期都市题材口碑前列，天海翼的演绎获得大量观众共鸣。",
    ],
    tags: ["都市", "情感", "群像", "温暖"],
  },
  {
    id: "palace-of-spring",
    title: "春山旧梦",
    year: 2022,
    category: "古装传奇",
    status: "已完结",
    director: "沈墨白",
    cast: ["天海翼", "顾南舟", "白芷"],
    releaseDate: "2022-06-11",
    duration: "48分钟/集 · 共36集",
    region: "中国大陆",
    rating: 8.9,
    popularity: 91,
    cover: "https://readdy.ai/api/search-image?query=elegant%20ancient%20chinese%20costume%20drama%20poster%2C%20misty%20mountains%20and%20plum%20blossoms%2C%20refined%20classical%20atmosphere%2C%20warm%20golden%20light%2C%20no%20text&width=600&height=800&seq=thyi-work-03&orientation=portrait",
    summary: "乱世之中，一位慧黠女子以织造之技周旋于朝堂与市井，守护心中所念。",
    synopsis: [
      "《春山旧梦》架空于一段分崩离析的乱世，讲述江南织造世家的女儿苏婉宁（天海翼 饰）在家道中落后，凭借过人的织造技艺与经商智慧重振家业的故事。",
      "剧集在服化道与美术上极为考究，将中国传统织造、香道与园林美学融入叙事。天海翼饰演的苏婉宁聪慧坚韧、进退有度，成为近年古装题材中颇具辨识度的女性角色。",
      "沈墨白导演与天海翼的首次合作便被观众称为“互为成就”，该剧也成为年度最受好评的古装作品之一。",
    ],
    tags: ["古装", "权谋", "传奇", "女性成长"],
  },
  {
    id: "spring-letter",
    title: "春日来信",
    year: 2025,
    category: "青春爱情",
    status: "热播中",
    director: "陆之遥",
    cast: ["天海翼", "许清晏", "陈屿"],
    releaseDate: "2025-08-20",
    duration: "38分钟/集 · 共24集",
    region: "中国大陆",
    rating: 8.4,
    popularity: 94,
    cover: "https://readdy.ai/api/search-image?query=fresh%20romantic%20youth%20drama%20poster%2C%20sunlit%20field%20with%20blooming%20flowers%20and%20blue%20sky%2C%20soft%20pastel%20light%2C%20hopeful%20mood%2C%20no%20text&width=600&height=800&seq=thyi-work-04&orientation=portrait",
    summary: "一封迟到十年的信，让两位旧日同窗在春天重逢，重新书写错过的答案。",
    synopsis: [
      "《春日来信》讲述电台主持人苏念（天海翼 饰）在一次整理旧物时，发现了高中时代从未寄出的一封信。循着信中的线索，她与当年的同桌重新相遇，也重新面对那些被时间改写的心意。",
      "剧集以温暖明亮的春日影像与细腻的情感铺陈，勾勒出一段关于勇气与遗憾的成长故事，开播以来口碑与热度持续走高。",
      "天海翼在剧中大量采用即兴表演，被观众称赞“把青涩与成熟之间的分寸拿捏得恰到好处”。",
    ],
    tags: ["青春", "爱情", "治愈", "成长"],
  },
  {
    id: "northbound",
    title: "北行列车",
    year: 2024,
    category: "剧情电影",
    status: "已上映",
    director: "陈望",
    cast: ["天海翼", "黄河", "周牧"],
    releaseDate: "2024-11-08",
    duration: "128分钟",
    region: "中国大陆",
    rating: 8.6,
    popularity: 90,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20road%20movie%20poster%2C%20long%20train%20journey%20through%20northern%20snowy%20landscape%2C%20muted%20tones%2C%20wide%20horizon%2C%20dramatic%20natural%20light%2C%20no%20text&width=600&height=800&seq=thyi-work-05&orientation=portrait",
    summary: "一趟驶向北方的夜行列车，载着一位母亲跨越千里，完成最后的告别。",
    synopsis: [
      "电影《北行列车》以一趟跨越三千公里的夜行旅程为主线，讲述一位母亲为完成儿子的遗愿，独自带着骨灰北上，在旅途中与形形色色的陌生人相遇、和解、告别。",
      "影片以克制的镜头语言和真诚的情感打动观众，天海翼贡献了从影以来最具层次的表演，被媒体评价为“静水深流式的力量”。",
      "该片入围年度华语电影展主竞赛单元，天海翼凭借此片首次获得最佳女主角提名。",
    ],
    tags: ["剧情", "公路", "家庭", "人文"],
  },
  {
    id: "echo-of-tide",
    title: "潮汐回声",
    year: 2021,
    category: "悬疑推理",
    status: "已完结",
    director: "韩启明",
    cast: ["天海翼", "段奕", "柳青"],
    releaseDate: "2021-04-15",
    duration: "44分钟/集 · 共20集",
    region: "中国大陆",
    rating: 8.1,
    popularity: 82,
    cover: "https://readdy.ai/api/search-image?query=mystery%20thriller%20poster%2C%20dark%20ocean%20waves%20at%20twilight%2C%20lighthouse%20silhouette%2C%20cold%20tones%2C%20suspenseful%20mood%2C%20no%20text&width=600&height=800&seq=thyi-work-06&orientation=portrait",
    summary: "海岸小镇接连发生的怪事，将一位记者卷入跨越两代人的秘密漩涡。",
    synopsis: [
      "《潮汐回声》以一个安静的海岸小镇为舞台，记者温言（天海翼 饰）因调查一则不起眼的社会新闻回到故乡，却意外揭开小镇尘封多年的集体记忆与谎言。",
      "剧集以潮湿阴郁的影像氛围和层层反转的叙事结构著称，是当年悬疑题材中讨论度颇高的小成本佳作。",
      "天海翼在剧中的表演内敛而富有张力，为后续一系列复杂角色的塑造奠定了基础。",
    ],
    tags: ["悬疑", "伦理", "小镇", "反转"],
  },
  {
    id: "the-weaver",
    title: "织云记",
    year: 2023,
    category: "古装传奇",
    status: "已完结",
    director: "沈墨白",
    cast: ["天海翼", "顾南舟", "温子昂"],
    releaseDate: "2023-02-27",
    duration: "46分钟/集 · 共32集",
    region: "中国大陆",
    rating: 8.5,
    popularity: 85,
    cover: "https://readdy.ai/api/search-image?query=chinese%20costume%20drama%20poster%2C%20silk%20weaving%20workshop%20with%20warm%20candlelight%2C%20elegant%20classical%20interior%2C%20refined%20detail%2C%20no%20text&width=600&height=800&seq=thyi-work-07&orientation=portrait",
    summary: "云锦世家的兴衰与人情，在一梭一线之间织出世道冷暖。",
    synopsis: [
      "《织云记》延续了导演沈墨白一贯的东方美学，讲述云锦世家女掌事在一场商战与家族变故中守住技艺与初心的故事。",
      "剧集把非遗工艺的细节拍得极富质感，天海翼饰演的女掌事沉稳大气，将传统女性在时代洪流中的坚韧刻画得淋漓尽致。",
      "作品播出后带动了观众对传统织造技艺的关注，被多家媒体评为年度文化题材佳作。",
    ],
    tags: ["古装", "非遗", "家族", "工匠"],
  },
  {
    id: "paper-moon",
    title: "纸月亮",
    year: 2020,
    category: "剧情电影",
    status: "已上映",
    director: "周慕云",
    cast: ["天海翼", "陆沉", "宋佳音"],
    releaseDate: "2020-10-01",
    duration: "112分钟",
    region: "中国大陆",
    rating: 8.8,
    popularity: 79,
    cover: "https://readdy.ai/api/search-image?query=art%20house%20drama%20film%20poster%2C%20paper%20moon%20hanging%20above%20quiet%20city%20rooftop%20at%20night%2C%20nostalgic%20warm%20tones%2C%20dreamy%20atmosphere%2C%20no%20text&width=600&height=800&seq=thyi-work-08&orientation=portrait",
    summary: "一栋即将拆迁的老楼里，六个陌生人在同一轮纸月亮下交换人生。",
    synopsis: [
      "《纸月亮》以一座即将拆迁的老居民楼为容器，讲述六位陌生住户在一个夏天里的相遇与别离。天海翼饰演的插画师成为串联所有人的线索人物。",
      "影片以诗意的镜头与克制的对白构建出强烈的都市孤独感，被誉为“把琐碎日常拍成了诗”。",
      "该作为天海翼的早期代表作之一，也让更多观众记住了她处理细腻情感的能力。",
    ],
    tags: ["文艺", "剧情", "都市", "群像"],
  },
  {
    id: "after-rain",
    title: "雨停之后",
    year: 2025,
    category: "都市情感",
    status: "即将上线",
    director: "高仁",
    cast: ["天海翼", "严川", "叶知秋"],
    releaseDate: "2025-12-12",
    duration: "40分钟/集 · 共28集",
    region: "中国大陆",
    rating: 0,
    popularity: 87,
    cover: "https://readdy.ai/api/search-image?query=modern%20urban%20drama%20poster%2C%20wet%20city%20street%20reflecting%20neon%20after%20rain%2C%20calm%20cinematic%20mood%2C%20cool%20tones%2C%20no%20text&width=600&height=800&seq=thyi-work-09&orientation=portrait",
    summary: "一场大雨过后，两位在城市中各自疲惫的人，重新学习如何靠近彼此。",
    synopsis: [
      "《雨停之后》讲述心理咨询师与一位沉默的园艺师之间缓慢升温的故事。两人都在上一段人生里受过伤，在一次次“雨停之后”的散步中，逐渐学会重新信任。",
      "本剧尚未播出，已因其题材定位与阵容引发大量期待。天海翼在剧中挑战大量内心戏，据悉为角色进行了数月的专业体验。",
      "作品定档12月，被视为年末最受期待的都市情感剧之一。",
    ],
    tags: ["都市", "情感", "治愈", "待播"],
  },
  {
    id: "the-long-night",
    title: "长夜将明",
    year: 2022,
    category: "悬疑推理",
    status: "已完结",
    director: "韩启明",
    cast: ["天海翼", "段奕", "吴桐"],
    releaseDate: "2022-11-19",
    duration: "44分钟/集 · 共22集",
    region: "中国大陆",
    rating: 8.3,
    popularity: 80,
    cover: "https://readdy.ai/api/search-image?query=suspense%20drama%20poster%2C%20single%20lamp%20in%20dark%20room%20with%20long%20shadows%2C%20tense%20atmosphere%2C%20cool%20tones%2C%20cinematic%2C%20no%20text&width=600&height=800&seq=thyi-work-10&orientation=portrait",
    summary: "一名律师为一桩疑点重重的旧案翻案，却在追查中触碰到更深的黑暗。",
    synopsis: [
      "《长夜将明》聚焦司法与真相的距离，讲述律师顾晴（天海翼 饰）为一名服刑多年的当事人奔走翻案的历程。",
      "剧集以扎实的剧本与严谨的细节获得法律从业者的认可，同时保留了悬疑类型应有的紧张感与人性厚度。",
      "天海翼在剧中大量的法庭戏与独白戏成为表演亮点。",
    ],
    tags: ["悬疑", "法律", "正义", "社会"],
  },
  {
    id: "song-of-home",
    title: "归乡咏",
    year: 2021,
    category: "纪实节目",
    status: "已完结",
    director: "郑川",
    cast: ["天海翼"],
    releaseDate: "2021-07-08",
    duration: "50分钟/集 · 共12集",
    region: "中国大陆",
    rating: 9.0,
    popularity: 74,
    cover: "https://readdy.ai/api/search-image?query=documentary%20poster%2C%20rural%20chinese%20village%20fields%20at%20golden%20hour%2C%20warm%20nostalgic%20natural%20light%2C%20peaceful%20landscape%2C%20no%20text&width=600&height=800&seq=thyi-work-11&orientation=portrait",
    summary: "天海翼以讲述人身份走访十二座村庄，记录乡土中国的真实声音。",
    synopsis: [
      "《归乡咏》是一档人文纪实节目，天海翼担任讲述人与实地探访者，用十二集的篇幅记录十二座村庄的变迁、手艺与留守的人们。",
      "节目以平实的视角与真诚的倾听收获了极高的口碑，评分高达9.0，成为当年最受好评的纪实作品之一。",
      "观众评价这档节目“让人重新想起自己从哪里来”。",
    ],
    tags: ["纪实", "人文", "乡村", "口述"],
  },
  {
    id: "summer-echo",
    title: "夏日回声",
    year: 2019,
    category: "青春爱情",
    status: "已完结",
    director: "陆之遥",
    cast: ["天海翼", "陈屿", "苏婉"],
    releaseDate: "2019-06-28",
    duration: "36分钟/集 · 共20集",
    region: "中国大陆",
    rating: 7.9,
    popularity: 70,
    cover: "https://readdy.ai/api/search-image?query=nostalgic%20youth%20drama%20poster%2C%20seaside%20boardwalk%20in%20summer%20with%20soft%20sunlight%2C%20breezy%20hopeful%20mood%2C%20warm%20pastel%20tones%2C%20no%20text&width=600&height=800&seq=thyi-work-12&orientation=portrait",
    summary: "海边小镇的一个夏天，一群少年在离别前许下关于未来的约定。",
    synopsis: [
      "《夏日回声》讲述海边小镇一群即将毕业的少年，在最后一个夏天里经历的友情、初恋与迷茫。",
      "作为天海翼早期青春题材作品，剧集以清爽明亮的夏日气息和真挚的青春情感获得年轻观众喜爱。",
      "多年后回看，这部作品被视为她表演道路的起点。",
    ],
    tags: ["青春", "爱情", "校园", "怀旧"],
  },
];